<template>
  <button class="flex h-full items-center py-2.5" type="button">
    <span v-if="text" class="text-text-neutral-primary">
      <span data-qa-id="searchFormInput.text ">{{ text }}</span>
      <span
        v-if="suffix"
        data-qa-id="searchFormInput.suffix"
        class="text-text-neutral-quaternary"
      >
        {{ suffix }}
      </span>
    </span>
    <span
      v-else-if="placeholder"
      :class="
        hasError ? 'text-text-negative-primary' : 'text-text-neutral-quaternary'
      "
    >
      {{ placeholder }}
    </span>
  </button>
</template>

<script setup lang="ts">
  defineProps<{
    text?: string;
    suffix?: string;
    placeholder?: string;
    hasError?: boolean;
  }>();
</script>
